var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 76,
    viewBox: "0 0 113 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.105 14.2924C87.1106 -17.1191 25.8465 -15.9846 6.74753 -0.143346C-12.3514 15.6979 14.359 33.7988 67.074 64.6941C119.789 95.5894 168.097 53.5568 123.105 14.2924Z",
    fill: "#EBF3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingVector);
export default __webpack_public_path__ + "static/media/onboarding-vector.a2f08cea.svg";
export { ForwardRef as ReactComponent };